import React, { useState, useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { TITLE, NAME, PHONE, LAT, LON } from '../../utils/constant';
import { getQueryVariable } from '../../utils/util';
import { HeaderStore } from '../../stores/';
import './index.scss';

import logoIcon from '../../assets/header/logo.png';
import phoneIcon from '../../assets/header/phone.png';
import navigationIcon from '../../assets/header/navigation.png';
import musicIcon from '../../assets/header/music.png';
import musicForbidIcon from '../../assets/header/music_forbid.png';


declare global {
	interface Window {
		wx: any;
	}
}

const Header = observer((props: any) => {
	// 营销人员名单
	let salesmanInfos = [{
		name: '中海锦宸',
		phone: PHONE
	}];

	const [name] = useState<string>(NAME);
	const [logo] = useState<string>(logoIcon);
	const [phone] = useState<string>(phoneIcon);
	const [navigation] = useState<string>(navigationIcon);
	const [currSale, setCurrSale] = useState<Array<any>>([]);   // 当前营销人员信息
	const audioEl = useRef<any>(null);

	useEffect(() => {
		// iphone不能自动播放音频，用微信的jssdk
		window.wx && window.wx.ready(() => HeaderStore.isPlay ? audioEl.current.pause() : audioEl.current.play());

		let saleId = getQueryVariable('saleId');   // 获取地址栏的营销人员id
		let arr = salesmanInfos.filter(item => saleId === item.phone); // 匹配地址栏的音效人员id有没有在印象人员名单里
		arr.length > 0 && setCurrSale(arr);   // 拿到当前营销人员的信息
	}, []);

	useEffect(() => {
		setTimeout(() => {
			HeaderStore.isPlay ? audioEl.current.pause() : audioEl.current.play();
		}, 0)
	}, [HeaderStore.isPlay])

	// 切换音乐
	const handleMusic = (): void => {
		HeaderStore.isPlay ? audioEl.current.pause() : audioEl.current.play();
		HeaderStore.setIsPlay(!HeaderStore.isPlay);
	}

	//判断是否微信登陆
	const isWeiXin = (): boolean => {
		var ua = navigator.userAgent.toLowerCase();
		return ua.indexOf('micromessenger') !== -1 ? true : false;
	}

	// 点击导航
	const handleNavgation = (): void => {
		if (isWeiXin()) {
			window.wx.openLocation({
				latitude: LAT,
				longitude: LON,
				scale: 8, // 缩放比例
				name: TITLE,
				address: TITLE,
			})
		} else {
			props.history.replace('/map');   // 跳转路由
		}
	}

	return <header>
		<div className="left">
			<div className="avatar-wrap">
				<img className="avatar" src={logo} alt="" />
			</div>
			<div className="content">
				{/* <div className="phone-wrap">
					<span className="name">{!!currSale[0] ? currSale[0].name : name}</span>
					{!!currSale[0] && <span className="salePhone">{!!currSale[0] ? currSale[0].phone : PHONE}</span>}

				</div>
				<span className="phone">{PHONE}</span> */}
				{/* <span className="phone">{!!currSale[0] ? currSale[0].phone : PHONE}</span> */}
			</div>
		</div>
		<div className="right">
			{/* 如果有特定营销人员名单的话就用匹配到的营销人员电话号码 */}
			{/* <a href={`tel:${!!currSale[0] ? currSale[0].phone : PHONE}`} className="phone"> */}
			<a href={`tel:${PHONE}`} className="phone">
				<img className="icon" src={phone} alt='' />
			</a>
			<span className="line" />
			<img onClick={() => handleNavgation()} className="icon" src={navigation} alt='' />
			<span className="line" />
			<img
				className="icon"
				src={HeaderStore.isPlay ? musicForbidIcon : musicIcon}
				onClick={() => handleMusic()}
				alt=''
			/>
		</div>

		{/* 背景音乐 */}
		<audio
			ref={audioEl}
			loop={true}
			autoPlay={true}
		>
			<source src='./audio/bgm.mp3' type="audio/mpeg" />
		</audio>

	</header>
})

export default withRouter(Header);
